import { Collapse, List } from '@mui/material';
import { Fragment } from 'react/jsx-runtime';
import SideBarItem from './SideBarItem';
import { MenuItem } from './SideBarItems';
import useIsAuthorized from './useIsAuthorized';
import { useState, useCallback } from 'react';

type Props = {
  menuItem: MenuItem;
  isSideBarOpen: boolean;
};

const SideBarList = ({ menuItem, isSideBarOpen }: Props) => {
  const checkIsAuthorized = useIsAuthorized();

  const [isMenuOpen, setMenuOpen] = useState(true);

  const toggleMenuOpen = useCallback(() => setMenuOpen(!isMenuOpen), [isMenuOpen]);

  return (
    <Fragment key={menuItem.id}>
      <SideBarItem isSideBarOpen={isSideBarOpen} item={menuItem} toggleMenuOpen={toggleMenuOpen} />

      {menuItem.children && isSideBarOpen && (
        <Collapse component="li" in={isMenuOpen} timeout="auto" unmountOnExit>
          <List disablePadding sx={{ marginLeft: 3 }}>
            {menuItem.children
              .filter(({ roles }) => checkIsAuthorized(roles))
              .map((entry) => (
                <SideBarItem child key={entry.id} isSideBarOpen={isSideBarOpen} item={entry} />
              ))}
          </List>
        </Collapse>
      )}
    </Fragment>
  );
};

export default SideBarList;
